<template>
  <div id="app" class="app side-o" :class="menu ? 'side-x side-ox' : ''">

    <Nav :menu="menu" />
    <Header :menu="menu" />
    <div class="pages">
      <router-view/>
    </div>
    <footer class="footer mt-auto py-3 d-none">
      <div class="container">
        <div data-v-12f348c0="" data-v-7b275293="" class="contactanos"><span data-v-12f348c0="">Comience a transformar su empresa hoy</span><div data-v-12f348c0="" class="dvBoton"><a data-v-12f348c0="" href="/Contacto" class="">Contactanos</a></div></div>
      </div>
    </footer>
  </div>
</template>

<style>

  html, body {
    margin: 0;
    padding: 0;
    min-height: 100%;
    height: 100%;
    width: 100%;
    font-family: Nunito Sans;
    font-size: 14px;
    color: #444444;
    min-width: 400px;
    font-weight: 200;
  }

  body {
    background-color: #f8f9fa !important;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.bg-blue {
  background-color: #063e69;
}

.bg-azul {
    background-color: #0665d0;
}

@keyframes fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes outFade {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

</style>
<script>
    import { mapActions, mapState, mapMutations } from 'vuex'
    import Nav from "./components/Nav";
    import Header from "./components/Header";
    export default {
        components: {Header, Nav},
        computed: {
            ...mapState([
                'showLogin',
                'loading',
                'usuario',
                'menu',
                'showLoginAnimated',
            ]),
        },

        data() {
            return {
                size: 1000
            }
        },

        beforeMount: function () {
            let token = localStorage.getItem("user");

            if (token && token !== '') {
                this.SET_USUARIO(JSON.parse(token));
            }

        },

        mounted: function () {
          window.addEventListener('resize', (event) => {
              this.resize();
          });
            this.resize();
        },

        methods: {

            ...mapMutations([
                'SET_USUARIO',
                'SET_MENU',
            ]),

            resize: function () {
                if (this.size >= 992 && window.innerWidth <= 992) {
                    this.size = window.innerWidth;
                    this.SET_MENU(false);
                } else if (window.innerWidth >= 992 && this.size <= 992){
                    this.size = window.innerWidth;
                }
            },

        }
    }
</script>

<style lang="scss">
  @import "./style/base";
  @include importMontserrat;
  @include importRoboto;
  @include importNunito;

  .title {
    @include title;
  }

  .subtitle {
      @include importMuli;
    @include Muli;
    @include fontFormat(20px, 700, #000000);
  }


  .app {
    &.side-ox {
      & .sidebar {
        transform: translateX(0) translateY(0) translateZ(0);
      }
    }

    @include responsive_layout('media_992') {
      &.side-o {
        & .sidebar {
          width: 240px;
        }
      }
      &.side-x {
        & .sidebar {
          transform: translateX(0) translateY(0) translateZ(0);
        }

        & .page-header {
          padding-left: 240px;
        }

        & .pages {
          padding-left: 240px;
        }

      }

      & .tacha {
        display: none;
      }

    }

    h6 {
      font-size: 10px;
    }

    .has-error {
      border-color: #dc3545;
      padding-right: calc(1.5em + .75rem);
      background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
      background-repeat: no-repeat;
      background-position: right calc(.375em + .1875rem) center;
      background-size: calc(.75em + .375rem) calc(.75em + .375rem);
      box-shadow: rgb(255, 0, 0) 0px 0px 1.5px 1px;
    }

    .has-error-2 {
      & .v-select {
        & .vs__dropdown-toggle {
          border-color: #dc3545;
          box-shadow: rgb(255, 0, 0) 0px 0px 1.5px 1px;
        }
      }
    }

    .hover:HOVER {
      opacity: 0.8;
    }

    .cursor {
      cursor: pointer;
    }

    .dvLoading {
      position: fixed;
      top: 50%;
    }

  }

</style>